'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('ui.tabs', []).directive('tabs', function () {
  return {
    restrict: 'E',
    transclude: true,
    scope: {},
    controller: function controller($scope, $element) {
      "ngInject";

      var panes = $scope.panes = [];

      $scope.select = function (pane) {
        _angular2.default.forEach(panes, function (pane) {
          pane.selected = false;
        });
        pane.selected = true;
      };

      this.addPane = function (pane) {
        if (panes.length == 0) $scope.select(pane);
        panes.push(pane);
      };
    },
    template: '<div class="row">' + '<div class="col-xs-3" style="width: 90px;">' + '<ul class="nav nav-tabs tabs-left" style="background-color: #eee; padding-top:0;">' + '<li ng-repeat="pane in panes" ng-class="{active:pane.selected}">' + '<a href="" ng-click="select(pane)">{{pane.title}}</a>' + '</li>' + '</ul>' + '</div>' + '<div class="col-xs-9" style="width: calc(100% - 90px);">' + '<div class="tab-content" ng-transclude></div>' + '</div>' + '</div>',

    replace: true
  };
}).directive('pane', function () {
  return {
    require: '^tabs',
    restrict: 'E',
    transclude: true,
    scope: { title: '@' },
    link: function link(scope, element, attrs, tabsController) {
      tabsController.addPane(scope);
    },
    template: '<div class="tab-pane" ng-class="{active: selected}" ng-transclude>' + '</div>',
    replace: true
  };
}).name;

// WEBPACK FOOTER //
/**
 * Created by murzik on 10.10.16.
 */


/** WEBPACK FOOTER **
 ** ./client/app/ui/tabs/index.js
 **/